module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-4ec9e17119d264f1a3c5b02f0038f949.png";